import React, { useEffect, useState, useRef } from "react";
import ScoreReferenceGuide from "../components/JudgeScoreCard/ScoreReferenceGuide";
import CategoryScoreCard from "../components/JudgeScoreCard/CategoryScoreCard";
import { SubCategory, ScoreCard, Category, Score } from "../types";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import ScoreCardHeader from "../components/JudgeScoreCard/ScoreCardHeader";
import StatusMessage from "../components/StatusMessage";
import Skeleton from "react-loading-skeleton";
import ThreeLineCardSkeleton from "../components/SkeletonCards/ThreeLineCardSkeleton";

import {useLocation} from 'react-router-dom';
import { useReactToPrint } from "react-to-print";


//const JudgeScoreCard: React.FC<{ handleLogout: () => void }> = (props: { handleLogout: () => void }) => {
const JudgeScoreCard: React.FC = () => {
  //const { handleLogout } = props;

  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  const params = useParams<{ performance_id: string }>();
  const performance_id = params?.performance_id;
  const [scoreCard, setScoreCard] = useState<any>({});
  const [isSubmitTrue, setIsSubmitTrue] = useState(true);
  const [isPageViewOnly, setIsPageViewOnly] = useState(false);
  const [judgesInitials, setJudgesInitials] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [totalScore, setTotalScore] = useState<number>(0);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [scoreCardSubmitted, setScoreCardSubmitted] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const [scorePageState, setScorePageState] = useState('create');

  const currentRole = JSON.parse(localStorage.getItem("user") || '{}').current_role;
  const currentUserID = JSON.parse(localStorage.getItem("user") || '{}').id;
  const scoreStoragekey = 'scorecard-'+currentUserID+'-'+performance_id;
  
  const location = useLocation();
  const judge_id = location?.state?.judge_id;

  const userData = localStorage.getItem("user");

  let judgeTotal = 0;

  const navigate = useNavigate();
  
  const fetchScoreCard = async () => {
    if(currentRole == 3 || currentRole == 6) setIsPageViewOnly(true);
    
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("No token found");
      }
      
      let getdatauri = import.meta.env.VITE_API_URL+'/scores/getjudgescorecard/'+performance_id;
      //if(currentRole == 1 || currentRole == 8 || currentRole == 3 || currentRole == 6) getdatauri = getdatauri+'?judge_id='+judge_id;
      if(currentRole != 5) getdatauri = getdatauri+'?judge_id='+judge_id;
      
      const response = await fetch(
        getdatauri,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (result.success) {
        setScoreCard(result.data);
        if((currentRole == 1 || currentRole == 8) && result.data.scorecard.user_judge_id == null) setIsSubmitTrue(false);
        if(result?.data?.scorecard?.user_judge_id) setScorePageState('update');
        if(!result?.data?.scorecard?.is_editing_allowed) setIsPageViewOnly(true);
        
        if(!result?.data?.scorecard?.user_judge_id && currentRole == 5){
          if (localStorage.hasOwnProperty(scoreStoragekey)){
           setScoreCard(eval('(' + localStorage.getItem(scoreStoragekey) + ')'));
          }else{
            localStorage.setItem(scoreStoragekey, JSON.stringify(result.data));
          } 
        }
        //localStorage.getItem("user")
        if(currentRole == 5 && userData){
            const user = JSON.parse(userData);
            const { first_name, last_name } = user;
            setJudgesInitials(`${first_name} ${last_name}`);
        }else{
          setJudgesInitials(result?.data?.scorecard?.user_judge);
        }
        setIsLoading(false);
      } else {
        setError(result.message);
        throw new Error(result.message);
        //handleLogout();
      }
    } catch (err) {
      console.error(err);
      setError('<p>⚠️ Session expired. Please <a href="/login">login</a> again.</p>');
    }
  }

  useEffect(() => {
    fetchScoreCard();
  }, []);
  
  useEffect(() => {
    if (!scoreCard.scorecard) {
      return;
    }

    const newTotalScore = scoreCard.scorecard.categories.reduce(
      (total: number, category: Category) => {
        if (category.category_name === "POINTS DEDUCTION") {
          return total; // Skip this category
        }
        const score = category.scores[0]?.category_total_scores || 0;
        return total + score;
      },
      0
    );
    
    setTotalScore(newTotalScore);
  }, [scoreCard]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [isVisible]);

  if (error) return <div
  dangerouslySetInnerHTML={{
    __html: error,
  }}
/>;

  async function sendScoreCard() {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error(
          "⚠️ Session expired. Please <a href='/login'>login</a> again."
        );
      }

      const getcurrentRole = JSON.parse(localStorage.getItem("user") || '{}').current_role;
      if((scorePageState=='create' && (getcurrentRole == 1 || getcurrentRole == 8)) || getcurrentRole == 3 ||  getcurrentRole == 6){
        setSuccess(false);
        setResponseMessage('You are not authorized to perform this action!');
        return false;
      }

      const judgename = JSON.parse(localStorage.getItem("user") || '{}').first_name + " " + JSON.parse(localStorage.getItem("user") || '{}').last_name;
      const payload = {
        performance_id: performance_id,
        entry_number: scoreCard?.scorecard?.entry_number,
        event_id: scoreCard.scorecard.event_id,
        scores: transformScoreData(),
        judge_total_score: judgeTotal,
        division_group_id: scoreCard.scorecard.divisions_performance_groups_id,
        judge_id: scoreCard.scorecard.user_judge_id,
        judgename: judgename,
      };

      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/scores/setjudgescorecard`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();
      if (result.success) {
        setScoreCardSubmitted(true);
        setSuccess(true);
        setResponseMessage(result?.message);
        if(localStorage.hasOwnProperty(scoreStoragekey)) 
          localStorage.removeItem(scoreStoragekey);
        setTimeout(() => {
          if(currentRole == 1 || currentRole == 8){
            navigate(
              `/placements/${scoreCard?.scorecard?.divisions_performance_groups_id}`
            )
          }else{ 
            navigate(
              `/performances/${scoreCard?.scorecard?.divisions_performance_groups_id}`
            )
          }
        }, 450);
      } else {
        setScoreCardSubmitted(true);
        setSuccess(false);
        setResponseMessage(result?.message);
      }
      //console.log(result);
    } catch (error) {
      console.log(error);
    }
  }

  function transformScoreData() {
    if (!scoreCard || !scoreCard.scorecard || !scoreCard.scorecard.categories) {
      return [];
    }

    return scoreCard.scorecard.categories.map((category: Category) => {
      const subScores = category.subcategories.map((sc: SubCategory) => ({
        subcategory_id: sc.id,
        score: sc.subScores.length > 0 ? sc.subScores[0].score : 0,
      }));

      judgeTotal += category.scores[0]?.category_total_scores || 0;

      return {
        category_id: category.id,
        score: category.scores[0]?.category_total_scores || 0,
        comment: category.scores[0]?.category_comment || "",
        sub_scores: subScores,
      };
    });
  }

  const handleCommentChange = (categoryId: number, newComment: string) => {
    setScoreCard((prevScoreCard: ScoreCard) => {
      const updatedScoreCard = { ...prevScoreCard };

      const categories = updatedScoreCard?.scorecard?.categories?.map(
        (category) => {
          if (category.id === categoryId) {
            // Check if 'scores' exists and has data, otherwise initialize it
            const updatedScores = category.scores.length
              ? category.scores.map((score) => ({
                  ...score,
                  category_comment: newComment,
                }))
              : [
                  {
                    category_comment: newComment,
                    category_total_scores: 0,
                  } as Score,
                ];

            return {
              ...category,
              scores: updatedScores,
            };
          }
          return category;
        }
      );

      updatedScoreCard.scorecard.categories = categories;

      return updatedScoreCard;
    });
    if (localStorage.hasOwnProperty(scoreStoragekey) && scorePageState == 'create' && currentRole == 5){
      localStorage.setItem(scoreStoragekey, JSON.stringify(scoreCard));
    } 
  };

  const handleSubmitValidations = async () => {
      const scoreSections = document.querySelectorAll('.div-score-section');
      let isValid = true;

      scoreSections.forEach((section) => {
          const childNodes = section.querySelectorAll('#w-node-e37c566c-7a7e-a3ec-2f54-12b2c6960c6f-38e776aa');
          const hasActiveScore = Array.from(childNodes).some((node) =>
              node.classList.contains('activeScore')
          );

          // Remove existing validation messages
          const validationMessage = section.querySelector('.validation-error');
          if (validationMessage) {
              validationMessage.remove();
          }

          if (!hasActiveScore) {
              isValid = false;

              // Add validation error message
              const errorElement = document.createElement('div');
              errorElement.className = 'validation-error';
              errorElement.style.color = 'red';
              errorElement.textContent = 'No score is selected.';
              section.appendChild(errorElement);
          }
      });

      // Validate textareas
      const textareas = document.querySelectorAll<HTMLTextAreaElement>('.score__comment');
      textareas.forEach((textarea) => {
          // Remove existing validation messages
          const validationMessage = textarea.nextElementSibling as HTMLElement | null;
          if (validationMessage && validationMessage.classList.contains('validation-error')) {
              validationMessage.remove();
          }

          if (textarea.value.trim() === '') {
              isValid = false;

              // Add validation error message
              const errorElement = document.createElement('div');
              errorElement.className = 'validation-error';
              errorElement.style.color = 'red';
              errorElement.textContent = 'Please enter a comment.';
              if (textarea.parentNode) {
                  textarea.parentNode.insertBefore(errorElement, textarea.nextSibling);
              }
          }
      });
      return isValid;
  };
  
  return (
    <>
      {scoreCardSubmitted
        ? success
          ? isVisible && (
              <StatusMessage
                success={true}
                successMsg={responseMessage ? responseMessage : 'Scores updated successfully!'}
                failureMsg="Error updating Scores, Please try again!"
              />
            )
          : isVisible && (
              <StatusMessage
                success={false}
                successMsg="Scores updated successfully!"
                failureMsg={responseMessage ? responseMessage : 'Error updating Scores, Please try again!'}
              />
            )
        : null}
      
      <section>
        {isLoading ? (
          <div>
            <Skeleton style={{ height: "40px" }} />
          </div>
        ) : (
          <ScoreReferenceGuide
            scoreRanges={scoreCard.scores_range}
            scoreDescriptions={scoreCard.scores_description}
          />
        )}
      </section>
      <div ref={contentRef}>
      <section className="section-3">
        <div className="w-layout-blockcontainer container-main-content w-container">
          <div className="div-header-title-section">
          <a
            href="#"
            className="link-block w-inline-block"
            onClick={(e) => {
              e.preventDefault();
              
              if (document.referrer) {
                // If the user has a referrer (previous page), go back
                navigate(-1);
              } else {
                // If there's no referrer .e.g user came directly
                if ([5].includes(currentRole)) {
                  navigate(`/performances/${scoreCard?.scorecard?.divisions_performance_groups_id}`);
                } else {
                  navigate(`/placements/${scoreCard?.scorecard?.divisions_performance_groups_id}`);                  
                }
              }
            }}
          >
            <img
              src="images/back-icon.png"
              loading="lazy"
              alt=""
              className="image-2"
            />
            <h1 className="back-text-link">
              {scoreCard?.scorecard?.division_title.split('_')[0]}
            </h1>
          </a>
          </div>
        </div>
      </section>
      <section>
        {isLoading ? (
          <div>
            <Skeleton
              style={{
                height: "40px",
                width: "70%",
                marginLeft: "15%",
                marginBottom: "20px",
              }}
            />
          </div>
        ) : (
          <ScoreCardHeader
            performanceType={scoreCard?.scorecard?.performance_type}
            judgesInitials={judgesInitials}
            entry={scoreCard?.scorecard?.entry_number}
            routine={scoreCard?.scorecard?.routine.routine}
            program={scoreCard?.scorecard?.programdirector?.first_name}
            program_skills_abhs={scoreCard?.scorecard?.programdirector?.skills_abhs}
            program_skills_abhs_mod2={scoreCard?.scorecard?.programdirector?.skills_abhs_mod2}
            program_skills_pom_straps={scoreCard?.scorecard?.programdirector?.skills_pom_straps}
            danceStyle={scoreCard?.scorecard?.danceStyle?.style_title}
            performance_performers={scoreCard?.scorecard?.performance_performers}
          />
        )}
      </section>
      <section>
        {isLoading ? (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <ThreeLineCardSkeleton cardsCount={1} />
          </div>
        ) : (
          scoreCard.scorecard.categories
          .filter((category: Category) => category.id !== 10 && category.id !== 5)
          .map((category: Category) => {
            return (
              <CategoryScoreCard
                category_id={category.id}
                category_name={category.category_name}
                max_scores={category.max_scores}
                scores={category.scores}
                subcategories={category.subcategories}
                handleCommentChange={handleCommentChange}
                setScoreCard={setScoreCard}
                scoreCard={scoreCard}
                scoreStoragekey={scoreStoragekey}
                scorePageState={scorePageState}
                currentRole={currentRole}
                isPageViewOnly = {isPageViewOnly}
                key={category.id}
              />
            );
          })
        )}
      </section>
      <br/>
      <section>
        <div className="w-layout-blockcontainer w-container">
          <div
            id="w-node-_455de618-dc4b-4b5d-1911-440f2cb526d9-38e776aa"
            className="w-layout-layout quick-stack-6 wf-layout-layout"
          >
            <div
              id="w-node-_455de618-dc4b-4b5d-1911-440f2cb526da-38e776aa"
              className="w-layout-cell cell-3"
            >
              <p className="paragraph-8">Total: {totalScore}/100</p>
            </div>
            <div
              id="w-node-_455de618-dc4b-4b5d-1911-440f2cb526dd-38e776aa"
              className="w-layout-cell cell-2"
            >
            {isPageViewOnly ? (
              <a className="button-2 w-button" onClick={() => reactToPrintFn()}>Print</a>
            ) : (
              <a
                href="#"
                className={`button-2 w-button ${!isSubmitTrue ? 'not-allowed':''}`}
                onClick={async () => {
                    if(isSubmitTrue){
                      const isValid = await handleSubmitValidations(); // Run validation
                      if (!isValid) {
                          console.log('Validation failed. Not proceeding.');
                          return; // Stop execution if validation fails
                      }

                      // Proceed only if validation passed
                      await sendScoreCard();
                      setIsVisible(true);
                    } 
                }}
            >
                Submit Score
            </a>
            )}
            </div>
          </div>
        </div>
      </section>
      </div>
    </>
  );
};

export default JudgeScoreCard;
